<template>
	<v-container fluid class="pa-2 mx-2">
		<v-toolbar color="primary" dark flat class="mt-3">
			<v-toolbar-title class="text-h5">Centro de Mando Integra (Dashboard v3.0)</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" @click="fetchData">
						<v-icon>mdi-refresh</v-icon>
					</v-btn>
				</template>
				<span>Recargar datos</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" @click="showLocalDiagnosis = true">
						<v-icon color="white">mdi-stethoscope</v-icon>
					</v-btn>
				</template>
				<span>Diagnóstico Operativo Automático</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" @click="showAIDiagnosis = true">
						<v-icon color="white">mdi-brain</v-icon>
					</v-btn>
				</template>
				<span>Análisis Estratégico IA (Abierto)</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" @click="getMetaAnalysisByDate">
						<v-icon>mdi-file-code-outline</v-icon>
					</v-btn>
				</template>
				<span>Exportar reporte(JSON)</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn icon v-on="on" @click="dialogBudgets = true">
						<v-icon>mdi-table-arrow-up</v-icon>
					</v-btn>
				</template>
				<span>Cargar Presupuestos</span>
			</v-tooltip>
		</v-toolbar>

		<v-tabs v-model="tab" @change="onTabChange" grow background-color="grey lighten-4">
			<v-tab>Resumen</v-tab>
			<v-tab>Cockpit</v-tab>
			<v-tab>Radar Marketing</v-tab>
			<v-tab>Piso Ventas</v-tab>
			<v-tab>Auditoría Leads</v-tab>
			<v-tab>Flujo Capital</v-tab>
		</v-tabs>

		<v-tabs-items v-model="tab" class="pa-4">
			<!-- Resumen -->
			<v-tab-item>
				<v-row>
					<v-col cols="12" md="6">
						<v-card outlined>
							<v-card-title>Distribución por Plantel</v-card-title>
							<v-data-table :headers="plantelHeaders" :items="plantelItems" :item-class="plantelRowClass"
								dense class="elevation-1">
								<template v-slot:body.append="{ headers }">
									<tr class="font-weight-bold grey lighten-3 elevation-1">
										<td>TOTAL</td>
										<td class="text-end">{{ plantelTotals.total }}</td>
										<td class="text-end">{{ plantelTotals.completos }}</td>
										<td class="text-end">{{ plantelTotals.incompletos }}</td>
										<td class="text-end">{{ plantelTotals.interactuados }}</td>
									</tr>
								</template>
							</v-data-table>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card outlined>
							<v-card-title>Distribución por Estado</v-card-title>
							<v-data-table :headers="estadoHeaders" :items="estadoItems" dense class="elevation-1">
								<template v-slot:body.append="{ headers }">
									<tr class="font-weight-bold grey lighten-3">
										<td>TOTAL</td>
										<td class="text-end">{{ estadoTotals.total }}</td>
										<td class="text-end">{{ estadoTotals.completos }}</td>
										<td class="text-end">{{ estadoTotals.incompletos }}</td>
										<td class="text-end">{{ estadoTotals.interactuados }}</td>
									</tr>
								</template>
							</v-data-table>
						</v-card>
					</v-col>
				</v-row>
				<v-row class="mt-4">
					<v-col cols="12" md="4">
						<v-card color="blue lighten-5">
							<v-card-title class="subtitle-1">Total leads detallados</v-card-title>
							<v-card-text class="text-h4 text-center">{{ totalLeadsDetallados }}</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="4">
						<v-card color="orange lighten-5">
							<v-card-title class="subtitle-1">Leads sin plantel asignado</v-card-title>
							<v-card-text class="text-h4 text-center">{{ leadsSinPlantel.length }}</v-card-text>
						</v-card>
					</v-col>
					<v-col cols="12" md="4">
						<v-card color="grey lighten-4">
							<v-card-title class="subtitle-1">Leads sin estado</v-card-title>
							<v-card-text class="text-h4 text-center">{{ leadsSinEstado.length }}</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<!-- Conjuntos críticos (sin cambios) -->
				<v-card outlined class="mt-6">
					<v-card-title>Conjuntos Críticos</v-card-title>
					<v-data-table :headers="criticalHeaders" :items="conjuntosCriticos"></v-data-table>
				</v-card>
			</v-tab-item>
			<!-- Cockpit Ejecutivo -->
			<v-tab-item>
				<v-row>
					<v-col cols="12" md="7">
						<v-card outlined class="pa-4">
							<v-card-title class="headline">
								Embudo de Conversión
								<v-chip class="ml-4" small color="primary">{{ resumen.total_leads }} leads
									totales</v-chip>
							</v-card-title>
							<v-card-text>
								<canvas ref="funnelChart"></canvas>
								<div class="d-flex flex-wrap justify-center mt-4">
									<v-tooltip bottom v-for="(stage, i) in funnelStages" :key="i">
										<template v-slot:activator="{ on }">
											<v-chip large class="ma-2" :color="defineFunnelColor(i)" dark v-on="on">
												<v-icon left>{{ stage.icon }}</v-icon>
												{{ stage.label }}: {{ stage.value }}
											</v-chip>
										</template>
										<v-simple-table dense>
											<thead>
												<tr>
													<th>Fuente</th>
													<th>Cantidad</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(v, k) in stage.breakdown" :key="k">
													<td>{{ k }}</td>
													<td>{{ v }}</td>
												</tr>
											</tbody>
										</v-simple-table>
									</v-tooltip>
								</div>
							</v-card-text>
						</v-card>
					</v-col>

					<v-col cols="12" md="5">
						<v-card outlined class="pa-4">
							<v-card-title class="headline">
								Salud Financiera
								<v-chip class="ml-3" small color="primary" dark>
									Presupuesto: ${{
										resumenFinancieroGlobal.presupuesto_diario | decimales
									}}
								</v-chip>
								<v-chip class="ml-3" small :color="resumen.gasto_total > resumenFinancieroGlobal.presupuesto_diario
									? 'red darken-1'
									: 'green darken-1'
									" dark>
									Gasto: ${{ resumen.gasto_total | decimales }}
								</v-chip>
							</v-card-title>
							<v-card-subtitle>
								<v-expansion-panels accordion class="mt-4" v-model="panelSaludF">
									<v-expansion-panel v-for="(branch, index) in budgetsByBranch" :key="index"
										class="elevation-0">
										<v-expansion-panel-header>
											<span class="text-h6">
												{{ branch.city }}
											</span>
										</v-expansion-panel-header>
										<v-expansion-panel-content>
											<v-row>
												<v-col>
													<span>Presupuesto: ${{ branch.daily_cap_total | decimales }}</span>
													<br />
													<span>Gasto total: ${{ branch.gasto_total | decimales }}</span>
													<br />
												</v-col>
											</v-row>
											<v-row v-for="(gasto, index) in branch.sucursales" :key="index">
												<v-col>
													<span>{{ gasto.sucursal }}</span>
												</v-col>
												<v-col>
													<v-chip class="ml-3" small color="primary" dark>
														Presupuesto: ${{ gasto.daily_cap | decimales }}
													</v-chip>
												</v-col>
												<v-col>
													<v-chip class="ml-3" small :color="gasto.gasto > gasto.daily_cap
														? 'red darken-1'
														: 'green darken-1'
														" dark>
														Gasto: ${{ gasto.gasto | decimales }}
													</v-chip>
												</v-col>
											</v-row>
										</v-expansion-panel-content>
									</v-expansion-panel>
								</v-expansion-panels>
							</v-card-subtitle>
							<v-card-text>
								<v-list dense>
									<v-list-item v-for="fin in processedData.financials" :key="fin.sucursal">
										<v-list-item-content>
											<v-list-item-title>{{ fin.sucursal }}</v-list-item-title>
											<v-list-item-subtitle>
												Gasto ${{ fin.gasto | decimales }}
												<v-chip x-small class="ml-2"
													:color="getBarColor(fin.gasto, fin.presupuesto)">
													{{ fin.leads }} leads
												</v-chip>
											</v-list-item-subtitle>
											<v-progress-linear :value="fin.presupuesto > 0 ? (fin.gasto / fin.presupuesto) * 100 : 0
												" :color="getBarColor(fin.gasto, fin.presupuesto)" height="20" rounded>
												<strong>{{
													fin.presupuesto > 0 ? Math.round((fin.gasto / fin.presupuesto) * 100) : 0
												}}%</strong>
											</v-progress-linear>
										</v-list-item-content>
										<v-list-item-action> </v-list-item-action>
									</v-list-item>
								</v-list>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>

				<v-row class="mt-6">
					<v-col cols="12">
						<v-card outlined class="pa-4">
							<v-card-title class="headline">
								Mapa de Calor Horario
								<v-chip class="ml-4" small color="teal" dark>Hora pico: {{ resumen.horas_pico
								}}:00</v-chip>
							</v-card-title>
							<v-card-text>
								<canvas ref="hourlyChart"></canvas>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
			</v-tab-item>

			<!-- Radar de Marketing -->
			<v-tab-item>
				<v-row>
					<v-col cols="12" md="6">
						<v-card outlined class="text-center pa-6" :color="processedData.actions.kill.length > 0 ? 'red lighten-4' : 'grey lighten-4'
							">
							<v-icon size="60" color="error">mdi-fire</v-icon>
							<div class="text-h4 mt-4">{{ processedData.actions.kill.length }}</div>
							<div class="subtitle-1">Anuncios tóxicos</div>
							<v-btn class="mt-4" color="error" dark @click="showKillDialog = true"
								:disabled="processedData.actions.kill.length === 0">
								Detalle
							</v-btn>
						</v-card>
					</v-col>
					<v-col cols="12" md="6">
						<v-card outlined class="text-center pa-6"
							:color="processedData.actions.scale.length > 0 ? 'green lighten-4' : 'grey lighten-4'">
							<v-icon size="60" color="success">mdi-rocket-launch</v-icon>
							<div class="text-h4 mt-4">{{ processedData.actions.scale.length }}</div>
							<div class="subtitle-1">Unicornios para escalar</div>
							<v-btn class="mt-4" color="success" dark @click="showScaleDialog = true"
								:disabled="processedData.actions.scale.length === 0">
								Detalle
							</v-btn>
						</v-card>
					</v-col>
				</v-row>

				<v-card outlined class="mt-6">
					<v-card-title>
						Campañas Tóxicas (>60% incompletos)
						<v-chip class="ml-4" color="red" dark>{{ toxicCampaigns.length }}</v-chip>
					</v-card-title>
					<v-text-field v-model="searchToxicCampaigns" prepend-inner-icon="mdi-magnify" label="Buscar"
						class="mx-4" clearable></v-text-field>
					<v-data-table :headers="toxicHeaders" :items="toxicCampaigns" :item-class="toxicRowClass"
						:search="searchToxicCampaigns">
						<template v-slot:item.details="{ item }">
							<v-btn class="mx-2" fab dark x-small color="primary" @click="showToxicDetail(item)">
								<v-icon dark>
									mdi-magnify
								</v-icon>
							</v-btn>
						</template>
					</v-data-table>
				</v-card>
			</v-tab-item>

			<!-- Resto de pestañas (mantengo estructura similar pero con más color y chips) -->
			<v-tab-item>
				<v-card outlined>
					<v-card-title>Rendimiento de Vendedoras</v-card-title>
					<v-data-table :headers="salesHeaders" :items="salesPerformance">
						<template v-slot:item.quality="{ item }">
							<v-chip :color="defineColorSellers(item, 'quality')" dark small>
								{{ item.quality }}%
							</v-chip>
						</template>
						<template v-slot:item.engagement="{ item }">
							<v-chip :color="defineColorSellers(item)" dark small>
								{{ item.engagement }}%
							</v-chip>
						</template>
						<template v-slot:body.append="{ headers }">
							<tr class="font-weight-bold grey lighten-3">
								<td>TOTAL</td>
								<td class="text-start">{{ vendedorasTotals.volume }}</td>
								<td class="text-start">{{ vendedorasTotals.complete }}</td>
								<td class="text-start">{{ vendedorasTotals.incomplete }}</td>
								<td class="text-start">{{ vendedorasTotals.interacted }}</td>
								<td class="text-start"></td>
								<td class="text-start"></td>
							</tr>
						</template>
					</v-data-table>
				</v-card>
			</v-tab-item>

			<v-tab-item>
				<v-card outlined>
					<v-card-title>Auditoría de Leads</v-card-title>
					<v-text-field v-model="search" prepend-inner-icon="mdi-magnify" label="Buscar" class="mx-4"
						clearable></v-text-field>
					<v-data-table :headers="leadsHeaders" :items="processedData.allLeads" :search="search"
						:items-per-page="20">
						<template v-slot:item.ad_id="{ item }">
							{{ item.ad_id ? item.ad_id : item.clasificacion }}
						</template>
					</v-data-table>
				</v-card>
			</v-tab-item>

			<v-tab-item>
				<v-card outlined>
					<v-card-title>Matriz Flujo de Capital</v-card-title>
					<v-data-table :headers="flowHeaders" :items="capitalFlow"></v-data-table>
				</v-card>
			</v-tab-item>
		</v-tabs-items>

		<!-- Diálogos -->
		<v-dialog v-model="showKillDialog" max-width="900">
			<v-card>
				<v-card-title class="headline red white--text">Anuncios Tóxicos</v-card-title>
				<v-data-table :headers="killHeaders" :items="processedData.actions.kill" single-expand
					:expanded.sync="expandedKillTable" item-key="ad_id" show-expand class="elevation-2">
					<template v-slot:expanded-item="{ headers, item }">
						<td :colspan="headers.length" class="pa-6 grey lighten-4">
							<v-row>
								<v-col cols="12" md="6">
									<strong>ID Anuncio:</strong> {{ item.ad_id }}<br>
									<strong>Nombre:</strong> {{ item.ad_name }}<br>
									<strong>Plantel:</strong> {{ item.branch }}<br>
								</v-col>
								<v-col cols="12" md="6">
									<strong>Detalle de leads:</strong><br>
									<v-virtual-scroll height="100" item-height="65"
										:items="item.crm_data.leads_details">
										<template v-slot:default="{ item }">
											<v-list-item>
												<v-list-item-content>
													<v-list-item-title>{{ item.plantel.toUpperCase() }}
													</v-list-item-title>
													<v-list-item-subtitle>{{ item.nombre_completo.toUpperCase()
													}}</v-list-item-subtitle>
													<v-list-item-subtitle>{{ item.twilio }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-virtual-scroll>
								</v-col>
							</v-row>
						</td>
					</template>
					<template v-slot:item.spend="{ item }">
						<span>${{ item.spend | decimales }}</span>
					</template>
				</v-data-table>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogToxicDetail" max-width="900">
			<v-card>
				<v-card-title class="headline primary white--text mb-2">Detalle de campaña</v-card-title>
				<v-card-subtitle class="primary white--text">
					<span>
						{{ dataToxicDetail.campaign_name }}
					</span>
				</v-card-subtitle>
				<v-card-subtitle class="mt-2">
					<span><strong>Ad ID:</strong> {{ dataToxicDetail.ad_id }}</span><br>
					<span><strong>Ad name:</strong> {{ dataToxicDetail.ad_name }}</span><br>
					<span><strong>Plantel:</strong> {{ dataToxicDetail.branch }}</span><br>
					<span><strong>Clasificación:</strong> {{ dataToxicDetail.clasificacion | capitalize }}</span><br>
					<span><strong>Gasto:</strong> ${{ dataToxicDetail.spend | decimales }}</span><br>
					<span><strong>Acción: </strong>
						<v-chip v-if="dataToxicDetail.crm_data" class="white--text"
							:color="getAccionColor(dataToxicDetail.action)"> {{ dataToxicDetail.action |
								capitalize }}</v-chip>
					</span><br>
				</v-card-subtitle>
				<v-card-text class="pa-2 pt-4" v-if="dataToxicDetail.crm_data">
					<v-row class="mx-2 mb-3">
						<span class="back font-weight-bold">Detalle de Leads</span>
						<v-spacer></v-spacer>
						<v-text-field v-model="searchDataToxicDetail" append-icon="mdi-magnify" label="Search"
							single-line hide-details></v-text-field>
					</v-row>
					<v-data-table :headers="dataToxicDetailHeaders" :items="dataToxicDetail.crm_data.leads_details"
						:search="searchDataToxicDetail" class="elevation-0">
						<template v-slot:item.ReferralHeadline="{ item }">
							<span>{{ item.ReferralHeadline || "Sin dato" }}</span>
						</template>
						<template v-slot:item.ReferralSourceUrl="{ item }">
							<a v-if="item.ReferralSourceUrl" target="_blank" :href="item.ReferralSourceUrl">{{
								item.ReferralSourceUrl }}</a>
							<span v-else>Sin dato</span>
						</template>
						<template v-slot:item.plantel="{ item }">
							<span>{{ item.plantel || "Sin dato" }}</span>
						</template>
						<template v-slot:item.origen_asignacion="{ item }">
							<span>{{ item.origen_asignacion || "Sin dato" }}</span>
						</template>
						<template v-slot:item.twilio="{ item }">
							<span>{{ item.twilio || "Sin dato" }}</span>
						</template>
						<template v-slot:item.vendedora="{ item }">
							<span>{{ item.vendedora || "Sin dato" }}</span>
						</template>
					</v-data-table>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showScaleDialog" max-width="800">
			<v-card>
				<v-card-title class="headline green white--text">Anuncios a Escalar</v-card-title>
				<v-data-table :headers="scaleHeaders" :items="processedData.actions.scale" single-expand
					:expanded.sync="expandedScaleTable" item-key="ad_id" show-expand class="elevation-1">
					<template v-slot:expanded-item="{ headers, item }">
						<td :colspan="headers.length" class="pa-6 grey lighten-4">
							<v-row>
								<v-col cols="12" md="6">
									<strong>ID Anuncio:</strong> {{ item.ad_id }}<br>
									<strong>Nombre:</strong> {{ item.ad_name }}<br>
									<strong>Plantel:</strong> {{ item.branch }}<br>
								</v-col>
								<v-col cols="12" md="6">
									<strong>Detalle de leads:</strong><br>
									<v-virtual-scroll height="100" item-height="65"
										:items="item.crm_data.leads_details">
										<template v-slot:default="{ item }">
											<v-list-item>
												<v-list-item-content>
													<v-list-item-title>{{ item.plantel.toUpperCase() }}
													</v-list-item-title>
													<v-list-item-subtitle>{{
														item.nombre_completo.toUpperCase() }}</v-list-item-subtitle>
													<v-list-item-subtitle>{{ item.twilio }}</v-list-item-subtitle>
												</v-list-item-content>
											</v-list-item>
										</template>
									</v-virtual-scroll>
								</v-col>
							</v-row>
						</td>
					</template>
					<template v-slot:item.spend="{ item }">
						<span>${{ item.spend | decimales }}</span>
					</template>
				</v-data-table>
			</v-card>
		</v-dialog>

		<v-dialog v-model="showAIDiagnosis" max-width="1200" scrollable transition="dialog-bottom-transition">
			<v-card class="rounded-xl overflow-hidden" elevation="24">
				<v-card-title class="headline indigo darken-4 white--text py-4 px-6">
					<v-icon large left color="white">mdi-brain</v-icon>
					Análisis Estratégico de Marketing (IA) — {{ fechaAnalisis }}
					<v-spacer></v-spacer>
					<v-btn icon dark @click="showAIDiagnosis = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>

				<v-card-text class="pa-0 grey lighten-5">
					<v-container fluid class="pa-0">
						<v-tabs v-model="activeTabIA" background-color="indigo darken-4" dark centered icons-and-text>
							<v-tab class="font-weight-bold">
								Global
								<v-icon>mdi-domain</v-icon>
							</v-tab>
							<v-tab class="font-weight-bold">
								Sucursales / Ciudad
								<v-icon>mdi-store</v-icon>
							</v-tab>
							<v-tab class="font-weight-bold">
								Campañas
								<v-icon>mdi-bullhorn</v-icon>
							</v-tab>
						</v-tabs>
						<v-tabs-items v-model="activeTabIA" class="grey lighten-5">
							<!-- PESTAÑA 1: VISIÓN GLOBAL -->
							<v-tab-item>
								<v-container fluid class="pa-6">
						<!-- NIVEL 1: ESCUELA -->
						<v-row v-if="diagnosticoIA && diagnosticoIA.escuela">
							<v-col cols="12">
								<v-card class="mb-6 elevation-4 rounded-lg overflow-hidden border-teal">
									<v-card-title class="teal darken-3 white--text py-2 px-4 subtitle-1">
										<v-icon small left color="white">mdi-office-building</v-icon>
										Visión Global (Nivel Escuela)
									</v-card-title>
									<v-card-text class="pa-6 bg-white">
										<div class="text-h5 mb-4 indigo--text text--darken-4 font-weight-bold border-bottom-soft pb-2">
											<v-icon color="indigo darken-4" class="mr-2">mdi-chart-line-variant</v-icon>
											Perspectiva Estratégica Global
										</div>
										<p class="text-body-1 line-height-relaxed grey--text text--darken-3 mb-6" style="font-size: 1.1rem !important; letter-spacing: 0.02em;">
											{{ diagnosticoIA.escuela.analisis }}
										</p>
										<v-alert border="left" colored-border color="indigo accent-4" elevation="2" class="pa-4 rounded-lg bg-indigo-lighten-5">
											<div class="text-subtitle-1 font-weight-black indigo--text text--darken-4 mb-1">
												Hoja de Ruta Directiva
											</div>
											<div class="text-body-1 grey--text text--darken-4">
												{{ diagnosticoIA.escuela.recomendacion }}
											</div>
										</v-alert>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
								</v-container>
							</v-tab-item>

							<!-- PESTAÑA 2: CIUDADES Y SUCURSALES -->
							<v-tab-item>
								<v-container fluid class="pa-6">
						<!-- NIVEL 2: CIUDADES -->
						<div class="text-h6 mb-3 px-2 font-weight-bold grey--text text--darken-3" v-if="diagnosticoIA && diagnosticoIA.ciudades && diagnosticoIA.ciudades.length">
							Análisis por Ciudad
						</div>
						<v-row v-if="diagnosticoIA && diagnosticoIA.ciudades">
							<v-col v-for="ciudad in diagnosticoIA.ciudades" :key="ciudad.nombre" cols="12" md="6">
								<v-card outlined class="mb-4 elevation-2 rounded-lg border-blue">
									<v-card-title class="blue darken-3 white--text py-1 px-3 subtitle-2">
										<v-icon x-small left color="white">mdi-city</v-icon>
										{{ ciudad.nombre }}
									</v-card-title>
									<v-card-text class="pa-3">
										<div class="mb-1"><strong>Análisis:</strong> {{ ciudad.analisis }}</div>
										<div class="green--text text--darken-3"><strong>Ajuste:</strong> {{ ciudad.recomendacion }}</div>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>

						<!-- NIVEL 3: SUCURSALES -->
						<div class="text-h6 mb-3 px-2 font-weight-bold grey--text text--darken-3" v-if="diagnosticoIA && diagnosticoIA.sucursales && diagnosticoIA.sucursales.length">
							Estatus por Sucursal
						</div>
						<v-row v-if="diagnosticoIA && diagnosticoIA.sucursales">
							<v-col v-for="suc in diagnosticoIA.sucursales" :key="suc.nombre" cols="12">
								<v-card outlined class="elevation-4 rounded-xl mb-6 overflow-hidden" :color="suc.estado === 'CRITICO'
									? 'red lighten-5'
									: suc.estado === 'ALERTA'
										? 'orange lighten-5'
										: 'green lighten-5'
									" style="border-width: 2px !important;" :style="{ borderColor: getStatusBorderColor(suc.estado) }">
									<v-card-title class="font-weight-black text-h5 py-4 px-6 d-flex align-center">
										{{ suc.nombre }}
										<v-spacer></v-spacer>
										<v-chip :color="suc.estado === 'CRITICO' ? 'red darken-2' : suc.estado === 'ALERTA' ? 'orange darken-2' : 'green darken-2'" dark class="font-weight-bold px-6">
											{{ suc.estado }}
										</v-chip>
									</v-card-title>
									<v-divider :color="getStatusBorderColor(suc.estado)"></v-divider>
									<v-card-text class="pa-6">
										<v-row>
											<v-col cols="12" md="7">
												<div class="mb-4">
													<div class="text-overline grey--text text--darken-1 mb-1">Análisis Detallado</div>
													<div class="text-body-1 line-height-relaxed grey--text text--darken-4" style="font-size: 1.05rem !important;">
														{{ suc.analisis }}
													</div>
												</div>
												<div class="pa-4 rounded-lg white elevation-1 border-left-thick" :style="{ borderLeftColor: getStatusBorderColor(suc.estado) }">
													<div class="text-subtitle-2 font-weight-bold mb-1" :style="{ color: getStatusBorderColor(suc.estado) }">Instrucción Operativa</div>
													<div class="text-body-1 grey--text text--darken-3">{{ suc.recomendacion }}</div>
												</div>
											</v-col>
											<v-col cols="12" md="5">
												<div v-if="suc.anuncios_especificos && suc.anuncios_especificos.length">
													<div class="text-overline red--text text--darken-2 mb-2">Auditoría de Anuncios Críticos</div>
													<v-list dense bg-color="transparent" class="pa-0">
														<v-list-item v-for="(anuncio, i) in suc.anuncios_especificos" :key="i" class="px-0 mb-2">
															<v-list-item-icon class="mr-2 mt-1">
																<v-icon color="red darken-2" small>mdi-close-octagon</v-icon>
															</v-list-item-icon>
															<v-list-item-content>
																<v-list-item-title class="text-body-2 line-height-base grey--text text--darken-4 text-wrap">
																	{{ anuncio }}
																</v-list-item-title>
															</v-list-item-content>
														</v-list-item>
													</v-list>
												</div>
											</v-col>
										</v-row>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
								</v-container>
							</v-tab-item>

							<!-- PESTAÑA 3: CAMPAÑAS -->
							<v-tab-item>
								<v-container fluid class="pa-6">
						<!-- NIVEL 4: RESUMEN DE CAMPAÑAS (NUEVO) -->
						<div v-if="diagnosticoIA && diagnosticoIA.nivel_campanas" class="mt-4">
							<div class="text-h6 mb-3 px-2 font-weight-bold grey--text text--darken-3 border-bottom-soft pb-2">
								<v-icon color="indigo darken-4" class="mr-2">mdi-bullseye-arrow</v-icon>
								Resumen a Nivel Campaña
							</div>
							
							<v-card class="elevation-3 rounded-lg mb-6 border-indigo">
								<v-card-text class="pa-5 bg-white">
									<div class="mb-4 d-flex align-center flex-wrap" style="gap: 8px;">
										<v-chip color="indigo darken-4" text-color="white" class="font-weight-bold">
											<v-icon left small>mdi-bullhorn</v-icon>
											{{ diagnosticoIA.nivel_campanas.total_activas }} Campañas Activas
										</v-chip>
										<v-chip v-if="diagnosticoIA.nivel_campanas.total_criticas" color="red darken-3" text-color="white" class="font-weight-bold">
											<v-icon left small>mdi-alert</v-icon>
											{{ diagnosticoIA.nivel_campanas.total_criticas }} en Riesgo (CPA Crítico)
										</v-chip>
									</div>

									<p class="text-body-1 line-height-relaxed grey--text text--darken-3 mb-4" style="font-size: 1.1rem !important;">
										{{ diagnosticoIA.nivel_campanas.resumen }}
									</p>

									<div v-if="campanasActivasItems.length" class="mt-4 pt-4" style="border-top: 1px dashed #e0e0e0;">
										<div class="d-flex align-center justify-space-between mb-3">
											<div class="text-caption grey--text text--darken-1 font-weight-bold d-flex align-center">
												<v-icon small color="grey" class="mr-1">mdi-table-large</v-icon> Panel Interactivo de Campañas:
											</div>
											<v-text-field v-model="searchCampanas" label="Buscar campaña..." hide-details prepend-inner-icon="mdi-magnify" single-line clearable dense outlined style="max-width: 300px;"></v-text-field>
										</div>
										<v-data-table :headers="campanasActivasHeaders" :items="campanasActivasItems" :search="searchCampanas" dense show-expand item-key="campana" class="elevation-1 table-striped table-hover rounded-lg">
											<template v-slot:item.gasto_total="{ item }">
												<span class="font-weight-medium text-red-darken-3">${{ item.gasto_total | decimales }}</span>
											</template>
											<template v-slot:item.cpa_completos="{ item }">
												<v-chip :color="item.cpa_completos > 40 ? 'red darken-1' : 'green darken-1'" text-color="white" small class="font-weight-bold">
													${{ item.cpa_completos | decimales }}
												</v-chip>
											</template>
											<template v-slot:expanded-item="{ headers, item }">
												<td :colspan="headers.length" class="pa-0">
													<v-card flat tile style="background-color: #fafafa; border-top: 1px solid #e0e0e0; border-bottom: 2px solid #ccc;">
														<v-card-text class="py-3 px-4">
															<div v-if="item.anuncios_parasitos && item.anuncios_parasitos.length" class="mb-2">
																<div class="font-weight-bold mb-1 d-flex align-center text-red-darken-3 text-caption">
																	<v-icon small color="red darken-3" class="mr-1">mdi-virus</v-icon> Anuncios Parásitos Detectados (Gasto sin completados):
																</div>
																<div class="d-flex flex-wrap" style="gap: 4px;">
																	<v-chip v-for="(anuncio, i) in item.anuncios_parasitos" :key="i" small color="red lighten-5" text-color="red darken-4" class="font-weight-medium mb-1">
																		{{ anuncio.nombre }}  <strong class="ml-1">(${{ anuncio.gasto | decimales }})</strong>
																	</v-chip>
																</div>
															</div>
															<div v-else class="text-caption grey--text">
																<v-icon small color="green" class="mr-1">mdi-check-circle</v-icon> Esta campaña no tiene anuncios parásitos.
															</div>
														</v-card-text>
													</v-card>
												</td>
											</template>
										</v-data-table>
									</div>
								</v-card-text>
							</v-card>
							
							<div v-if="diagnosticoIA.nivel_campanas.campanas_criticas && diagnosticoIA.nivel_campanas.campanas_criticas.length">
								<div class="text-subtitle-1 mb-4 red--text text--darken-2 font-weight-bold">
									<v-icon color="red darken-2" class="mr-2">mdi-alert-octagon</v-icon>
									Campañas Críticas (CPA Extremo)
								</div>
								<v-row>
									<v-col v-for="(campana, idx) in diagnosticoIA.nivel_campanas.campanas_criticas" :key="idx" cols="12" md="6">
														<v-card outlined class="elevation-1 rounded-lg border-red" style="background-color: #fff5f5;">
															<v-card-title class="red darken-3 white--text py-2 px-3 subtitle-2 d-flex justify-space-between align-center">
																<span class="text-truncate font-weight-bold" style="max-width: 70%">{{ campana.nombre }}</span>
																<v-chip color="white" text-color="red darken-3" small class="font-weight-black">
																	CPA: ${{ campana.cpa }}
																</v-chip>
															</v-card-title>
															<v-card-text class="pa-4" style="background-color: white;">
																<div class="mb-3">
																	<div class="text-caption font-weight-bold grey--text text--darken-1 mb-1">Diagnóstico y Recomendación</div>
																	<div class="text-body-2 grey--text text--darken-4">{{ campana.analisis_y_recomendacion }}</div>
																</div>
																<v-alert dense type="error" outlined class="mb-0 py-2 px-3" style="border-width: 2px;">
																	<div class="font-weight-bold text-caption mb-1 red--text text--darken-4">Limpieza de Anuncios Parásitos a Apagar YA:</div>
																	<ul class="pl-4 text-caption red--text text--darken-3 mb-0">
																		<li v-for="(anuncio, i) in campana.anuncios_parasitos_a_apagar" :key="i">{{ anuncio }}</li>
																	</ul>
																</v-alert>
															</v-card-text>
														</v-card>
									</v-col>
								</v-row>
							</div>
						</div>
								</v-container>
							</v-tab-item>
						</v-tabs-items>
					</v-container>
				</v-card-text>
				<v-card-actions class="pa-4 bg-white border-top">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-3" text @click="showAIDiagnosis = false" class="mr-2">Cerrar</v-btn>
					<v-btn v-if="diagnosticoIA" color="indigo darken-4" dark elevation="2" @click="exportReport(true)">
						<v-icon left>mdi-file-export</v-icon>
						Exportar Plan Estratégico
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- MODAL 2: DIAGNÓSTICO OPERATIVO (LOCAL) -->
		<v-dialog v-model="showLocalDiagnosis" max-width="1200" scrollable transition="dialog-bottom-transition">
			<v-card class="rounded-xl overflow-hidden" elevation="24">
				<v-card-title class="headline primary darken-2 white--text py-4 px-6">
					<v-icon large left color="white">mdi-stethoscope</v-icon>
					Diagnóstico Operativo Automático — {{ fechaAnalisis }}
					<v-spacer></v-spacer>
					<v-btn icon dark @click="showLocalDiagnosis = false"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>

				<v-card-text class="pa-0 grey lighten-5">
					<v-container fluid class="pa-6">
						<div class="text-h6 mb-4 px-2 font-weight-bold grey--text text--darken-3">
							Estatus de Rendimiento por Sucursal (Reglas Manuales)
						</div>
						<v-row>
							<v-col v-for="(diag, suc) in localLevelDiagnoses" :key="suc" cols="12" md="6" lg="4">
								<v-card outlined class="elevation-3 rounded-xl mb-4" :color="diag.status === 'CRITICO'
									? 'red lighten-5'
									: diag.status === 'ALERTA'
										? 'orange lighten-5'
										: 'green lighten-5'
									" style="border-width: 2px !important;" :style="{ borderColor: getStatusBorderColor(diag.status) }">
									<v-card-title class="font-weight-black subtitle-1">{{ suc }}</v-card-title>
									<v-card-text>
										<v-chip :color="diag.status === 'CRITICO'
											? 'red'
											: diag.status === 'ALERTA'
												? 'orange'
												: 'green'
											" dark small class="mb-3 font-weight-bold px-4">
											{{ diag.status }}
										</v-chip>
										<p class="text-body-2 mb-2"><strong>Análisis:</strong> {{ diag.analysis }}</p>
										<p class="text-body-2 mb-3 grey--text text--darken-3"><strong>Acción:</strong> {{ diag.action }}</p>
										
										<v-divider class="mb-2"></v-divider>
										
										<div class="d-flex justify-space-between mt-2">
											<span class="text-caption">Leads: <strong>{{ diag.leads }}</strong></span>
											<span class="text-caption">Calidad:
												<strong :class="diag.quality < 0.5 ? 'red--text' : 'green--text'">{{ (diag.quality * 100).toFixed(0) }}%</strong></span>
										</div>
										<div class="d-flex justify-space-between mt-1">
											<span class="text-caption">Gasto: <strong>${{ diag.spend | decimales }}</strong></span>
											<span class="text-caption">Presupuesto: <strong>${{ diag.budget | decimales }}</strong></span>
										</div>
									</v-card-text>
								</v-card>
							</v-col>
						</v-row>
					</v-container>
				</v-card-text>
				<v-card-actions class="pa-4 bg-white border-top">
					<v-spacer></v-spacer>
					<v-btn color="grey darken-3" text @click="showLocalDiagnosis = false" class="mr-2">Cerrar</v-btn>
					<v-btn color="primary" dark elevation="2" @click="exportReport(false)">
						<v-icon left>mdi-file-export</v-icon>
						Exportar JSON Operativo
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogBudgets" persistent max-width="600px">

			<v-card>
				<v-card-title class="headline">
					<v-icon left>mdi-microsoft-excel</v-icon>
					Cargar Presupuestos desde Excel
				</v-card-title>

				<v-card-text>
					<v-form ref="form" v-model="valid" lazy-validation>
						<v-row>
							<!-- Selección de Escuela -->
							<v-col cols="12" sm="6">
								<v-select v-model="form.school" :items="escuelas" item-text="nombre" item-value="id"
									label="Escuela" :rules="escuelaRules" outlined dense required></v-select>
							</v-col>

							<!-- Selección de Ciclo -->
							<v-col cols="12" sm="6">
								<v-select v-model="form.cycle_id" :items="ciclosConNuevo" item-text="texto"
									item-value="id" label="Ciclo de Marketing" :rules="cicloRules" clearable
									:loading="loadingCiclos" :disabled="creandoCiclo" outlined dense required
									@change="abrirDialogNuevoCicloSiEsNecesario"></v-select>
							</v-col>
						</v-row>

						<!-- Selección de Archivo Excel -->
						<v-row>
							<v-col cols="12">
								<v-file-input v-model="form.file" accept=".xlsx" label="Archivo Excel de Presupuestos"
									prepend-icon="mdi-file-excel" :rules="fileRules" show-size outlined dense
									required></v-file-input>
							</v-col>
						</v-row>
					</v-form>
					<v-alert v-if="mensaje" :type="mensajeTipo" dense class="mt-3">
						{{ mensaje }}
					</v-alert>

					<!-- Progress bar durante subida -->
					<v-progress-linear v-if="uploading" indeterminate color="primary" class="mt-3"></v-progress-linear>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeBudgetsDialog">Cancelar</v-btn>
					<v-btn color="primary" :disabled="!formCompleto" @click="uploadBudgets">
						<v-icon left>mdi-upload</v-icon>
						Subir y Procesar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogNuevoCiclo" persistent max-width="500px">
			<v-card>
				<v-card-title class="headline green lighten-5">
					<v-icon left color="green">mdi-plus-circle</v-icon>
					Crear Nuevo Ciclo de Marketing
				</v-card-title>

				<v-card-text class="pt-6">
					<v-form ref="formNuevoCiclo" v-model="validNuevoCiclo">
						<v-text-field v-model="nuevoCiclo.name" label="Nombre del ciclo" :rules="nuevoCicloRules.name"
							outlined dense required></v-text-field>

						<v-row>
							<!-- Fecha de inicio con Date Picker -->
							<v-col cols="12" sm="6">
								<v-menu v-model="menuStartDate" :close-on-content-click="false"
									transition="scale-transition" offset-y max-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="nuevoCiclo.start_date" label="Fecha de inicio"
											prepend-icon="mdi-calendar" readonly :rules="nuevoCicloRules.start_date"
											outlined dense required v-bind="attrs" v-on="on"></v-text-field>
									</template>
									<v-date-picker v-model="nuevoCiclo.start_date" no-title scrollable locale="es-mx"
										@input="menuStartDate = false"></v-date-picker>
								</v-menu>
							</v-col>

							<!-- Fecha de fin con Date Picker -->
							<v-col cols="12" sm="6">
								<v-menu v-model="menuEndDate" :close-on-content-click="false"
									transition="scale-transition" offset-y max-width="290px">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="nuevoCiclo.end_date" label="Fecha de fin"
											prepend-icon="mdi-calendar" readonly :rules="nuevoCicloRules.end_date"
											outlined dense required v-bind="attrs" v-on="on"></v-text-field>
									</template>
									<v-date-picker v-model="nuevoCiclo.end_date" no-title scrollable locale="es-mx"
										:min="nuevoCiclo.start_date" @input="menuEndDate = false"></v-date-picker>
								</v-menu>
							</v-col>
						</v-row>

						<v-alert type="info" dense class="mt-3">
							Este nuevo ciclo se utilizará por defecto para generar los reportes siguientes
						</v-alert>
					</v-form>
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="closeCycleDialog" :disabled="creandoCiclo">
						Cancelar
					</v-btn>
					<v-btn color="green" dark :loading="creandoCiclo" @click="crearNuevoCiclo">
						<v-icon left>mdi-check</v-icon>
						Crear Ciclo
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Chart from "chart.js/auto";

export default {
	data() {
		return {
			idSchool: 1,
			dataToxicDetail: {},
			dialogToxicDetail: false,
			searchToxicCampaigns: "",
			searchDataToxicDetail: "",
			searchCampanas: "",
			expandedKillTable: [],
			expandedScaleTable: [],
			tab: null,
			jsonData: null,
			panelSaludF: [0],
			processedData: {
				ads: [],
				allLeads: [],
				actions: { kill: [], scale: [] },
				financials: [],
			},
			showKillDialog: false,
			showScaleDialog: false,
			showAIDiagnosis: false,
			showLocalDiagnosis: false,
			search: "",
			diagnosticoIA: null,
			activeTabIA: 0,
			localLevelDiagnoses: {},
			funnelChartInstance: null,
			hourlyChartInstance: null,
			vendedorasDesglose: [],

			validNuevoCiclo: true,
			disableUploadBtn: false,
			dialogNuevoCiclo: false,
			dialogBudgets: false,
			valid: false,
			uploading: false,
			loadingCiclos: false,
			mensaje: '',
			mensajeTipo: 'info',
			menuStartDate: false,
			menuEndDate: false,
			form: {
				school: null,
				cycle_id: null,
				file: null,
			},

			// Listas estáticas
			escuelas: [
				{ id: 1, nombre: 'INBI' },
				{ id: 2, nombre: 'FAST' },
			],

			ciclos: [], // Se cargarán desde la API

			mostrarNuevoCiclo: false,
			nuevoCiclo: {
				name: '',
				start_date: '',
				end_date: '',
				active: 0, // por defecto activo
			},

			// Reglas para el nuevo ciclo
			nuevoCicloRules: {
				name: [v => !!v || 'El nombre del ciclo es obligatorio'],
				start_date: [v => !!v || 'La fecha de inicio es obligatoria'],
				end_date: [
					v => !!v || 'La fecha de fin es obligatoria',
					v => !v || !this.nuevoCiclo.start_date || new Date(v) >= new Date(this.nuevoCiclo.start_date) || 'La fecha de fin debe ser posterior o igual a la de inicio'
				],
			},

			creandoCiclo: false,

			// Reglas de validación
			escuelaRules: [
				v => !!v || 'Debes seleccionar una escuela',
			],
			cicloRules: [
				v => !!v || 'Debes seleccionar un ciclo',
			],
			fileRules: [
				v => !!v || 'Debes seleccionar un archivo Excel',
				v => !v || v.size < 10 * 1024 * 1024 || 'El archivo no debe superar los 10 MB',
				v => !v || /\.xlsx$/i.test(v.name) || 'Solo se permiten archivos .xlsx',
			],
		};
	},
	filters: {
		fixed2(value) {
			if (value == null) return "0.00";
			return Number(value).toFixed(2);
		},
		decimales(valor) {
			if (valor === null || valor === undefined || valor === "-") return "-";
			return Number(valor).toLocaleString("es-MX", {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			});
		},
		capitalize(value) {
			if (!value) return "";
			return value.charAt(0).toUpperCase() + value.slice(1);
		},
	},
	computed: {
		ciclosConNuevo() {
			const lista = [...this.ciclos];
			lista.unshift({
				id: 'nuevo',
				texto: 'Nuevo ciclo...',
			});
			return lista;
		},
		formCompleto() {
			return !!this.form.school &&
				!!this.form.cycle_id &&
				!!this.form.file;
		},
		isDataLoaded() {
			return (
				this.jsonData &&
				this.jsonData.cruce_enriquecido &&
				this.jsonData.cruce_enriquecido.resumen
			);
		},
		resumen() {
			return this.isDataLoaded ? this.jsonData.cruce_enriquecido.resumen : {};
		},
		resumenFinancieroGlobal() {
			return this.isDataLoaded ? this.jsonData.resumen_financiero.panel_completo : {};
		},
		resumenGasto() {
			return this.isDataLoaded ? this.jsonData.resumen_gasto : {};
		},
		fechaAnalisis() {
			return this.isDataLoaded
				? this.resumen.fecha_analisis || "Sin fecha"
				: "Cargando...";
		},
		distribucionPlanteles() {
			return this.isDataLoaded ? this.resumen.distribucion_planteles || {} : {};
		},
		distribucionEstados() {
			return this.isDataLoaded ? this.resumen.distribucion_estados || {} : {};
		},
		distribucionPlantelesDetallada() {
			if (!this.isDataLoaded) return {}

			const map = {}

			this.processedData.allLeads.forEach(lead => {
				// Siempre incluir, incluso si no hay plantel
				let plantel = lead.plantel || 'SIN PLANTEL';

				if (this.idSchool == 2) {
					plantel = this.detectSucursal(lead.campaign_name)
				}

				if (!map[plantel]) {
					map[plantel] = { total: 0, completos: 0, incompletos: 0, interactuados: 0 }
				}

				map[plantel].total++

				const isComplete = lead.nombre_completo && !lead.nombre_completo.toUpperCase().includes('INCOMPLETO')
				if (isComplete) {
					map[plantel].completos++
				} else {
					map[plantel].incompletos++
				}

				const hasInteraction =
					(lead.conversacion && lead.conversacion.length > 1) ||
					(lead.mensajes_entrada > 1) ||
					(lead.mensajes_salida > 0)

				// if (isComplete && hasInteraction) {
				// 	map[plantel].interactuados++
				// }

				if (isComplete && lead.leads_interactuados > 0) {
					map[plantel].interactuados++
				}
			})
			console.log(map);

			return map
		},

		distribucionEstadosDetallada() {
			if (!this.isDataLoaded) return {}

			const map = {}

			this.processedData.allLeads.forEach(lead => {
				let estado = lead.estado || 'Desconocido'
				
				if (this.idSchool == 2) {
					estado = "MONTERREY"
				}

				if (!map[estado]) {
					map[estado] = { total: 0, completos: 0, incompletos: 0, interactuados: 0 }
				}

				map[estado].total++

				const isComplete = lead.nombre_completo && !lead.nombre_completo.toUpperCase().includes('INCOMPLETO')
				if (isComplete) {
					map[estado].completos++
				} else {
					map[estado].incompletos++
				}

				const hasInteraction =
					(lead.conversacion && lead.conversacion.length > 1) ||
					(lead.mensajes_entrada > 1) ||
					(lead.mensajes_salida > 0)
				if (isComplete && lead.leads_interactuados) {
					map[estado].interactuados++
				}
			})

			return map
		},
		plantelTotals() {
			return this.plantelItems.reduce((acc, item) => ({
				total: acc.total + item.total,
				completos: acc.completos + item.completos,
				incompletos: acc.incompletos + item.incompletos,
				interactuados: acc.interactuados + item.interactuados
			}), { total: 0, completos: 0, incompletos: 0, interactuados: 0 })
		},
		estadoTotals() {
			return this.estadoItems.reduce((acc, item) => ({
				total: acc.total + item.total,
				completos: acc.completos + item.completos,
				incompletos: acc.incompletos + item.incompletos,
				interactuados: acc.interactuados + item.interactuados
			}), { total: 0, completos: 0, incompletos: 0, interactuados: 0 })
		},
		vendedorasTotals() {
			return this.salesPerformance.reduce((acc, item) => ({
				volume: acc.volume + item.volume,
				complete: acc.complete + item.complete,
				incomplete: acc.incomplete + item.incomplete,
				interacted: acc.interacted + item.interacted,
				quality: acc.quality + parseFloat(item.quality || 0),
				engagement: acc.engagement + parseFloat(item.engagement || 0)
			}), { volume: 0, complete: 0, incomplete: 0, interacted: 0, quality: 0, engagement: 0 })
		},
		leadsSinPlantel() {
			return this.processedData.allLeads.filter(lead => !lead.plantel || lead.plantel === 'SIN PLANTEL' || lead.plantel.trim() === '')
		},
		leadsSinEstado() {
			return this.processedData.allLeads.filter(lead => !lead.estado || lead.estado.trim() === '')
		},
		totalLeadsDetallados() {
			return this.processedData.allLeads.length
		},
		plantelHeaders() {
			return [
				{ text: 'Plantel', value: 'plantel' },
				{ text: 'Total', value: 'total', align: 'end' },
				{ text: 'Completos', value: 'completos', align: 'end' },
				{ text: 'Incompletos', value: 'incompletos', align: 'end' },
				{ text: 'Interactuados', value: 'interactuados', align: 'end' }
			]
		},
		plantelItems() {
			return Object.keys(this.distribucionPlantelesDetallada).map(key => ({
				plantel: key,
				total: this.distribucionPlantelesDetallada[key].total,
				completos: this.distribucionPlantelesDetallada[key].completos,
				incompletos: this.distribucionPlantelesDetallada[key].incompletos,
				interactuados: this.distribucionPlantelesDetallada[key].interactuados
			})).sort((a, b) => b.total - a.total)
		},
		campanasActivasHeaders() {
			return [
				{ text: 'Campaña', value: 'campana' },
				{ text: 'Gasto', value: 'gasto_total' },
				{ text: 'Leads', value: 'leads_totales' },
				{ text: 'Completos', value: 'leads_completos' },
				{ text: 'CPA Puros', value: 'cpa_completos' },
				{ text: '', value: 'data-table-expand' } // Para ver parásitos
			]
		},
		campanasActivasItems() {
			if (!this.isDataLoaded || !this.jsonData.campanas_activas) return [];
			return this.jsonData.campanas_activas;
		},
		estadoHeaders() {
			return [
				{ text: 'Estado', value: 'estado' },
				{ text: 'Total', value: 'total', align: 'end' },
				{ text: 'Completos', value: 'completos', align: 'end' },
				{ text: 'Incompletos', value: 'incompletos', align: 'end' },
				{ text: 'Interactuados', value: 'interactuados', align: 'end' }
			]
		},
		estadoItems() {
			return Object.keys(this.distribucionEstadosDetallada).map(key => ({
				estado: key,
				...this.distribucionEstadosDetallada[key]
			}))
		},
		conjuntosCriticos() {
			return this.jsonData ? this.jsonData.conjuntos_criticos || [] : [];
		},
		funnelStages() {
			if (!this.isDataLoaded) return [];
			const funnel = this.getFunnelMetrics();
			return [
				{
					label: "Total Leads",
					value: funnel.total.count,
					breakdown: funnel.total.breakdown,
					icon: "mdi-account-multiple",
				},
				{
					label: "Completos",
					value: funnel.complete.count,
					breakdown: funnel.complete.breakdown,
					icon: "mdi-check-circle",
				},
				{
					label: "Incompletos",
					value: funnel.incomplete.count,
					breakdown: funnel.incomplete.breakdown,
					icon: "mdi-alert-circle",
				},
				{
					label: "Interactuados",
					value: funnel.interacted.count,
					breakdown: funnel.interacted.breakdown,
					icon: "mdi-message-processing",
				},
			];
		},
		toxicHeaders() {
			return [
				{ text: "Campaña", value: "campaign_key" },
				{ text: "% Incompletos", value: "percentIncomplete" },
				{ text: 'Completos', value: 'complete' },
				{ text: 'Incompletos', value: 'incomplete' },
				{ text: "Total Leads", value: "total" },
				{ text: "Detalle leads", value: "details" },
			];
		},
		dataToxicDetailHeaders() {
			return [
				{ text: "Headline", value: "ReferralHeadline" },
				{ text: "URL", value: "ReferralSourceUrl" },
				{ text: 'Plantel', value: 'plantel' },
				{ text: "Origen Asignación", value: "origen_asignacion" },
				{ text: "Twilio", value: "twilio" },
				{ text: "Vendedora", value: "vendedora" },
			];
		},
		toxicCampaigns() {
			if (!this.isDataLoaded) return [];
			const campaigns = {};
			this.processedData.ads.forEach((ad, index) => {
				const key = ad.ad_id || `${ad.clasificacion.toUpperCase()}_${index}`;
				if (!campaigns[key]) campaigns[key] = { total: 0, complete: 0, incomplete: 0 };
				if (campaigns[key].total == 0) {
					campaigns[key].total = ad.crm_data.leads_details.length || 0
				}
				campaigns[key].ad_detail = ad
				const details = ad.crm_data.leads_details || ad.leads_details || [];
				details.forEach((lead) => {
					if (
						lead.nombre_completo &&
						lead.nombre_completo.toUpperCase().includes("INCOMPLETO")
					) {
						campaigns[key].incomplete++;
					} else {
						campaigns[key].complete++;
					}
				});
			});

			return Object.keys(campaigns).map((key) => {
				const d = campaigns[key];
				const percent = d.total > 0 ? (d.incomplete / d.total) * 100 : 0;
				return { campaign_key: key, percentIncomplete: percent.toFixed(1) + '%', total: d.total, complete: d.complete, incomplete: d.incomplete, ad_detail: d.ad_detail }
				// })
			}).filter(c => parseFloat(c.percentIncomplete) >= 60)
		},
		salesHeaders() {
			return [
				{ text: "Vendedora", value: "vendedora" },
				{ text: "Volumen", value: "volume" },
				{ text: "Completos", value: "complete" },
				{ text: "Incompletos", value: "incomplete" },
				{ text: "Interacciones", value: "interacted" },
				{ text: "Calidad %", value: "quality", align: "center" },
				{ text: "Enganche %", value: "engagement", align: "center" },
			];
		},
		salesPerformance() {
			if (!this.isDataLoaded) return [];
			const sellers = {};
			this.processedData.allLeads.forEach((lead) => {
				const seller = lead.vendedora || lead.name;
				if (!sellers[seller]) {
					sellers[seller] = { volume: 0, complete: 0, incomplete: 0, interacted: 0 };
				}
				sellers[seller].volume++;
				const completo = !lead.nombre_completo || !lead.nombre_completo.toUpperCase().includes("INCOMPLETO")
				if (completo) {
					sellers[seller].complete++;
				} else {
					sellers[seller].incomplete++;
				}
				if (lead.conversacion && lead.conversacion.length > 1) {
					sellers[seller].interacted++;
				}
				const vendedora = this.vendedorasDesglose.find(it => it.vendedora == seller)
				if (vendedora) {
					sellers[seller].interacted = vendedora.contactos
				}


				// const adsSeller = this.processedData.ads.filter(it => it.vendedora_principal_id == lead.vendedora_id)

				// if (completo && adsSeller && adsSeller.length) {	
				// 	sellers[seller].interacted++;
				// }


				// if (completo && adsSeller && adsSeller.length) {
				// 	adsSeller.forEach(fe => {
				// 		if (fe.atendidos_por_vendedora && fe.atendidos_por_vendedora[lead.vendedora_id]) {
				// 			sellers[seller].interacted += fe.atendidos_por_vendedora[lead.vendedora_id]
				// 		}
				// 	})

				// }
			});
			return Object.keys(sellers).map((key) => {

				const d = sellers[key];
				return {
					vendedora: key,
					complete: d.complete,
					incomplete: d.incomplete,
					interacted: d.interacted,
					volume: d.volume,
					quality: ((d.complete / d.volume) * 100).toFixed(1),
					engagement: ((d.interacted / d.volume) * 100).toFixed(1),
				};
			});
		},
		leadsHeaders() {
			return [
				{ text: "ID", value: "ad_id" },
				{ text: "Nombre", value: "name" },
				{ text: "Teléfono", value: "telefono" },
				{ text: "Plantel", value: "plantel" },
				{ text: "Estado", value: "estado" },
				{ text: "Fuente", value: "clasificacion" },
			];
		},
		flowHeaders() {
			return [
				{ text: "Origen", value: "origin" },
				{ text: "Destino", value: "destination" },
				{ text: "Cantidad", value: "count", align: "end" },
			];
		},
		capitalFlow() {
			if (!this.isDataLoaded) return [];
			const matrix = {};
			this.processedData.allLeads.forEach((lead) => {
				const origin = lead.branch_target || "Desconocido";
				const dest = lead.plantel || "SIN PLANTEL";
				const key = `${origin} → ${dest}`;
				if (!matrix[key]) matrix[key] = { origin, destination: dest, count: 0 };
				matrix[key].count++;
			});
			return Object.values(matrix).sort((a, b) => b.count - a.count);
		},
		criticalHeaders() {
			return [
				{ text: "Sucursal", value: "sucursal" },
				{ text: "Campaña", value: "campaign_name" },
				{ text: "Conjunto", value: "conjunto_de_anuncios" },
				{ text: "Activos", value: "anuncios_activos" },
			];
		},
		killHeaders() {
			return [
				{ text: "Campaña", value: "campaign_name" },
				{ text: "Anuncio", value: "ad_name" },
				{ text: "Gasto", value: "spend" },
				{ text: "Razón", value: "reason" },
				{ text: "CPA 7d", value: "tendencias.metrics_calculated.avg_cpa_7d" },
				{ text: "Leads promedio", value: "tendencias.metrics_calculated.avg_leads_7d" },
				{ text: "Acción", value: "action" },
			];
		},
		scaleHeaders() {
			return [
				{ text: "Campaña", value: "campaign_name" },
				{ text: "Anuncio", value: "ad_name" },
				{ text: "Gasto", value: "spend" },
				{ text: "Razón", value: "reason" },
				{ text: "CPA 7d", value: "tendencias.metrics_calculated.avg_cpa_7d" },
				{ text: "Leads promedio", value: "tendencias.metrics_calculated.avg_leads_7d" },
				{ text: "Acción", value: "action" },
			];
		},
		activeBudgets() {
			return this.isDataLoaded ? this.jsonData.activeBudgets : [];
		},
		budgetsByBranch() {
			if (!this.isDataLoaded) return [];

			if (!this.resumenGasto.por_sucursal || !this.activeBudgets) {
				return [];
			}

			// Crear un mapa: ciudad → objeto acumulado
			const agrupado = {};

			// Primero, procesamos activeBudgets para obtener la relación ciudad-sucursal y daily_cap
			this.activeBudgets.forEach((budget) => {
				const ciudad = budget.city;
				const sucursal = budget.branch;

				if (!agrupado[ciudad]) {
					agrupado[ciudad] = {
						city: ciudad,
						gasto_total: 0,
						leads_total: 0,
						daily_cap_total: 0,
						sucursales: [],
					};
				}

				// Agregamos el daily_cap de esta sucursal
				agrupado[ciudad].daily_cap_total += budget.daily_cap || 0;

				// Inicializamos la sucursal en el array (sin gasto/leads aún)
				const sucursalExistente = agrupado[ciudad].sucursales.find(
					(s) => s.sucursal === sucursal
				);
				if (!sucursalExistente) {
					agrupado[ciudad].sucursales.push({
						sucursal,
						gasto: 0,
						leads: 0,
						daily_cap: budget.daily_cap || 0,
					});
				} else {
					// Si ya existe (por duplicados improbables), sumamos daily_cap
					sucursalExistente.daily_cap += budget.daily_cap || 0;
				}
			});

			// Ahora, agregamos los datos reales de resumenGasto.por_sucursal
			this.resumenGasto.por_sucursal.forEach((item) => {
				let sucursal = item.sucursal;

				if (sucursal == "INBI ONLINE") sucursal = "ONLINE";
				// Buscamos a qué ciudad pertenece esta sucursal
				const budgetInfo = this.activeBudgets.find((b) => b.branch == sucursal);

				if (budgetInfo) {
					const ciudad = budgetInfo.city;

					if (!agrupado[ciudad]) {
						// En caso raro de que haya gasto pero no presupuesto activo
						agrupado[ciudad] = {
							city: ciudad,
							gasto_total: 0,
							leads_total: 0,
							daily_cap_total: 0,
							sucursales: [],
						};
					}

					// Sumar totales de la ciudad
					agrupado[ciudad].gasto_total += item.gasto || 0;
					agrupado[ciudad].leads_total += item.leads || 0;

					// Actualizar datos de la sucursal específica
					const sucursalEnCiudad = agrupado[ciudad].sucursales.find(
						(s) => s.sucursal === sucursal
					);
					if (sucursalEnCiudad) {
						sucursalEnCiudad.gasto = item.gasto || 0;
						sucursalEnCiudad.leads = item.leads || 0;
					} else {
						// Si por algún motivo no estaba en activeBudgets, la agregamos
						agrupado[ciudad].sucursales.push({
							sucursal,
							gasto: item.gasto || 0,
							leads: item.leads || 0,
							daily_cap: budgetInfo.daily_cap || 0,
						});
					}
				}
			});

			// Convertir el objeto agrupado a array y ordenar opcionalmente
			return Object.values(agrupado).sort((a, b) => a.city.localeCompare(b.city));
		},
	},
	watch: {
		'$route'(to, from) {
			this.defineIdSchool()
			this.fetchData();
			this.cargarCiclos()
		},
		jsonData(newVal) {
			if (newVal) {
				this.processRawData();
				this.getContactosAsignados()
				this.localLevelDiagnoses = this.generateAllAIDiagnoses();
				this.$nextTick(() => {
					this.renderCharts();
				});
			}
		},
	},
	created() {
		this.defineIdSchool()
	},
	mounted() {
		this.fetchData();
		this.cargarCiclos()
	},
	methods: {
		defineIdSchool() {
			this.idSchool = this.$route.name == "dashboardCampaniasInbi" ? 1 : 2
		},
		onTabChange(tabId) {

			if (tabId == 1) {
				// this.renderCharts()
				this.fetchData()
			}
		},
		async fetchData() {
			try {
				const data = await this.$http.get("api/meta/analyze/report/" + this.idSchool);
				if (data.data.success) {
					this.jsonData = data.data;
				}
			} catch (err) {
				console.error("Error cargando datos", err);
			}
		},
		toxicRowClass(item) {
			const perc = item.total > 0 ? (item.incomplete / item.total) * 100 : 0
			if (perc <= 70) {
				return 'red lighten-2';
			}
			if (perc <= 80) {
				return 'red darken-1 white--text';
			}
			if (perc <= 100) {
				return 'red darken-2 white--text';
			}
			return ''; // Sin clase adicional
		},
		plantelRowClass(item) {
			if (item.total <= 10) {
				return 'red darken-2 white--text';
			}
			if (item.total <= 30) {
				return 'amber darken-4';
			}
			if (item.total <= 50) {
				return 'amber darken-1';
			}
			if (item.total <= 60) {
				return 'lime darken-1';
			}
			if (item.total <= 70) {
				return 'green darken-1';
			}
			return ''; // Sin clase adicional
		},
		showToxicDetail(row) {
			this.dialogToxicDetail = true
			this.dataToxicDetail = row.ad_detail
		},
		getAccionColor(orden) {
			if (orden.includes('APAGAR')) return 'red darken-2'
			if (orden.includes('URGENTE')) return 'deep-orange darken-3'
			if (orden.includes('BAJAR')) return 'orange darken-3'
			if (orden.includes('CAMBIAR') || orden.includes('EDITAR')) return 'amber darken-1'
			if (orden.includes('MONITOREAR')) return 'blue darken-1'
			if (orden.includes('SIN PRESUPUESTO')) return 'blue-grey darken-1'
			return 'green darken-3'
		},
		defineFunnelColor(i) {
			if (i === 0) {
				return 'pink accent-2'
			} else if (i === 1) {
				return 'blue'
			} else if (i === 2) {
				return 'red'
			} else {
				return 'amber'
			}
		},
		defineColorSellers(row, from) {
			if (from == 'quality') {
				if (Number(row.quality) >= 70) return 'green';
				if (Number(row.quality) >= 60) return 'lime darken-1';
				if (Number(row.quality) >= 50) return 'amber darken-2';
				if (Number(row.quality) >= 40) return 'amber darken-4';
				return 'red'
			} else {
				if (Number(row.engagement) >= 70) return 'green';
				if (Number(row.engagement) >= 60) return 'lime darken-1';
				if (Number(row.engagement) >= 50) return 'amber darken-2';
				if (Number(row.engagement) >= 40) return 'amber darken-4';
				return 'red'
			}
		},
		processRawData() {
			const allAds = [];
			const allLeads = [];
			const kill = [];
			const scale = [];
			const financials = [];

			// 1. Anuncios de calidad_por_anuncio (objeto con ad_id como claves)
			const calidadObj = this.jsonData.cruce_enriquecido.calidad_por_anuncio || {};
			Object.keys(calidadObj).forEach((key) => {
				const ad = calidadObj[key];
				const processedAd = {
					ad_id: key,
					ad_name: ad.ad_name || "Anuncio sin nombre",
					campaign_name: ad.campaign_name || "",
					branch: ad.branch || "SIN PLANTEL",
					city: ad.city || "",
					spend: ad.spend || 0,
					total_leads: ad.total_leads || 0,
					complete: ad.complete || 0,
					incomplete: ad.incomplete || 0,
					crm_data: {
						leads_totales: ad.total_leads || 0,
						leads_details: ad.leads_details || [],
					},
					action: ad.action || "MONITOREAR",
					reason: ad.reason || "",
					clasificacion: ad.publisher_platform || "META_FACEBOOK",
					tasa_conversaciones_reales: ad.tasa_conversaciones_reales,
					leads_interactuados: ad.leads_interactuados,
					vendedora_principal_id: ad.vendedora_principal_id,
					atendidos_por_vendedora: ad.atendidos_por_vendedora
				};
				allAds.push(processedAd);

				// Extraer leads_details
				ad.leads_details.forEach((lead) => {
					allLeads.push({
						...lead,
						branch_target: processedAd.branch,
						clasificacion: lead.clasificacion || processedAd.clasificacion,
						campaign_name: processedAd.campaign_name,
						leads_interactuados: processedAd.leads_interactuados,

					});
				});
			});

			// 2. Leads externos (array de objetos con leads_details)
			const externos = this.jsonData.cruce_enriquecido.leads_externos || [];
			externos.forEach((ext) => {
				const processedAd = {
					ad_id: ext.ad_id || "EXTERNO",
					ad_name: ext.ad_name || "Fuente externa",
					campaign_name: ext.campaign_name || ext.clasificacion || "EXTERNO",
					branch: ext.branch || "SIN PLANTEL",
					spend: ext.spend || 0,
					crm_data: {
						leads_totales: ext.crm_data.leads_totales || 0,
						leads_details: ext.leads_details || [],
					},
					action: ext.action || "REPORTAR",
					reason: ext.reason || "Fuente externa",
					clasificacion: ext.clasificacion || "OTRO",
				};
				allAds.push(processedAd);

				// Extraer leads_details
				ext.leads_details.forEach((lead) => {
					allLeads.push({
						...lead,
						branch_target: processedAd.branch,
						clasificacion: lead.clasificacion || processedAd.clasificacion,
						campaign_name: processedAd.campaign_name,
					});
				});
			});

			// 3. Clasificar acciones
			this.jsonData.detalles_operativos.forEach((ad) => {
				if (ad.status.includes("APAGAR")) kill.push(ad);
				else if (ad.action.includes("SUBIR")) scale.push(ad);

			});

			// 4. Financials
			const porSucursal = this.jsonData.resumen_gasto.por_sucursal || [];
			porSucursal.forEach((s) => {
				financials.push({
					sucursal: s.sucursal || "Sin nombre",
					gasto: s.gasto || 0,
					presupuesto: s.daily_cap || 0,
					leads: s.leads || 0,
				});
			});

			this.processedData = {
				ads: allAds,
				allLeads,
				actions: { kill, scale },
				financials,
			};

			// Inyectar diagnóstico de la IA si existe en el JSON
			if (this.jsonData.diagnostico_ia) {
				const raw = this.jsonData.diagnostico_ia;
				this.diagnosticoIA = {
					escuela: raw.nivel_escuela || null,
					ciudades: raw.nivel_ciudad ? Object.entries(raw.nivel_ciudad).map(([nombre, data]) => ({ nombre, ...data })) : [],
					sucursales: raw.nivel_sucursal ? Object.entries(raw.nivel_sucursal).map(([nombre, data]) => ({ nombre, ...data })) : [],
					nivel_campanas: raw.nivel_campanas || null
				};
			}
		},
		getFunnelMetrics() {
			const sources = {
				INSTAGRAM: 0,
				FACEBOOK: 0,
				GOOGLE: 0,
				MERCA: 0,
				SUCURSAL: 0,
				OTRO: 0,
			};
			const funnel = {
				total: { count: 0, breakdown: { ...sources } },
				complete: { count: 0, breakdown: { ...sources } },
				incomplete: { count: 0, breakdown: { ...sources } },
				interacted: { count: 0, breakdown: { ...sources } },
			};

			this.processedData.allLeads.forEach((lead) => {
				let src = "OTRO";
				const clas = (lead.clasificacion || "").toUpperCase();

				if (clas.includes("FACEBOOK")) {
					src = "FACEBOOK";
				} else if (clas.includes("INSTAGRAM")) {
					src = "INSTAGRAM";
				} else if (clas.includes("GOOGLE") || clas.includes("LEAD_GOOGLE")) {
					src = "GOOGLE";
				} else if (clas.includes("MERCA") || clas.includes("MERCADO")) {
					src = "MERCA";
				} else if (clas.includes("SUCURSAL") || clas.includes("LEAD_SUCURSAL")) {
					src = "SUCURSAL";
				} else {
					src = "OTRO";
					if (lead.ReferralSourceUrl && lead.ReferralSourceUrl.includes("fb.me")) {
						src = "FACEBOOK";
					}
					if (lead.ReferralSourceUrl && lead.ReferralSourceUrl.includes("instagram")) {
						src = "INSTAGRAM";
					}
				}

				funnel.total.count++;
				funnel.total.breakdown[src]++;

				const isComplete =
					lead.nombre_completo &&
					!lead.nombre_completo.toUpperCase().includes("INCOMPLETO");
				if (isComplete) {
					funnel.complete.count++;
					funnel.complete.breakdown[src]++;
				} else {
					funnel.incomplete.count++;
					funnel.incomplete.breakdown[src]++;
				}
				const hasInteraction =
					(lead.conversacion && lead.conversacion.length > 1) ||
					lead.mensajes_entrada > 1 ||
					lead.mensajes_salida > 0 ||
					lead.mensajes_totales > 1;

				if (isComplete && lead.leads_interactuados > 0) {
					funnel.interacted.count++;
					funnel.interacted.breakdown[src]++;
				}
			});

			// Limpiar breakdown (eliminar claves con 0 si quieres, pero opcional)
			Object.keys(funnel.total.breakdown).forEach((key) => {
				if (funnel.total.breakdown[key] === 0) delete funnel.total.breakdown[key];
			});
			// Repetir para complete e interacted si lo deseas

			return funnel;
		},
		renderCharts() {
			if (this.funnelChartInstance) this.funnelChartInstance.destroy();
			const ctx1 = this.$refs.funnelChart;
			if (ctx1) {
				const data = this.getFunnelMetrics();
				this.funnelChartInstance = new Chart(ctx1, {
					type: "bar",
					data: {
						labels: ["Total", "Completos", "Incompletos", "Interactuados"],
						datasets: [
							{
								data: [data.total.count, data.complete.count, data.incomplete.count, data.interacted.count],
								backgroundColor: ["#FF4F8B", "#36A2EB", "#F55246", "#FFCE56"],
							},
						],
					},
					options: { responsive: true, plugins: { legend: { display: false } } },
				});
			}

			if (this.hourlyChartInstance) this.hourlyChartInstance.destroy();
			const hours = Array(24).fill(0);
			if (this.resumen.distribucion_horas) {
				this.resumen.distribucion_horas.forEach((h, i) => {
					hours[i] = h.leads || 0;
				});
			}
			const ctx2 = this.$refs.hourlyChart;
			if (ctx2) {
				this.hourlyChartInstance = new Chart(ctx2, {
					type: "bar",
					data: {
						labels: Array.from({ length: 24 }, (_, i) => `${i}:00`),
						datasets: [
							{
								label: "Leads",
								data: hours,
								backgroundColor: "#42A5F5",
							},
						],
					},
					options: { responsive: true, scales: { y: { beginAtZero: true } } },
				});
			}
		},
		getBarColor(gasto, presupuesto) {
			if (presupuesto === 0) return "grey"; // Barra gris si no hay presupuesto asignado
			return gasto > presupuesto ? "red" : "green";
		},
		detectSucursal(campaignName) {
			const upper = campaignName
				.toUpperCase()
				.normalize("NFD")
				.replace(/[\u0300-\u036f]/g, "");

			//FAST
			if (upper.includes("NORIA")) return "NORIA";
			if (upper.includes("ROMULO")) return "ROMULO GARZA";
			if (upper.includes("GARZA")) return "ROMULO GARZA";
			if (upper.includes("UNIVERSIDAD")) return "UNIVERSIDAD";
			if (upper.includes("UNI ")) return "UNIVERSIDAD";
			if (upper.includes("MITRAS")) return "MITRAS";
			if (upper.includes("ELOY")) return "ELOY CAVAZOS";
			if (upper.includes("CAVAZOS")) return "ELOY CAVAZOS";
			if (upper.includes("LINDA")) return "LINDA VISTA";
			if (upper.includes("VISTA")) return "LINDA VISTA";
			if (upper.includes("GUADALUPE")) return "GUADALUPE";

			//INBI
			if (upper.includes("ONLINE")) return "ONLINE";
			if (upper.includes("LINCOLN")) return "LINCOLN";
			if (upper.includes("SANTA CATARINA") || upper.includes("MTY SANTA"))
				return "SANTA CATARINA";
			if (upper.includes("ESCOBEDO")) return "ESCOBEDO";
			if (upper.includes("FRESNOS")) return "FRESNOS";
			if (upper.includes("MIGUEL ALEMAN")) return "MIGUEL ALEMÁN";
			if (upper.includes("PABLO LIVAS")) return "PABLO LIVAS";
			if (upper.includes("CASA BLANCA")) return "CASA BLANCA";
			if (upper.includes("SAN MIGUEL")) return "SAN MIGUEL";
			if (upper.includes("APODACA")) return "APODACA";
			if (upper.includes("CUITLAHUAC")) return "CUITLÁHUAC";
			if (upper.includes("MISTERIOS")) return "MISTERIOS";
			if (upper.includes("MONTEVIDEO")) return "MONTEVIDEO";
			if (upper.includes("ANAHUAC")) return "ANAHUAC";
			if (upper.includes("ARAGON")) return "ARAGON";
			if (
				upper.includes("REVOLUCION") ||
				(upper.includes("GDL") && !upper.includes("TRANSITO"))
			)
				return "GUADALAJARA REVOLUCIÓN";
			if (upper.includes("TRANSITO")) return "GUADALAJARA TRÁNSITO";
			if (upper.includes("ONLINE")) return "ONLINE";
			return "OTROS";
		},
		defineBranch(ad, sucursal) {
			if (ad.campaign_name) {
				const clean = ad.campaign_name
					.toUpperCase()
					.normalize("NFD")
					.replace(/[\u0300-\u036f]/g, "");

				return clean.includes(sucursal);
			}

			return false;
		},
		generateAIDiagnosis(sucursal) {
			const fin = this.processedData.financials.find((f) => f.sucursal === sucursal) || {
				gasto: 0,
				presupuesto: 0,
			};

			const adsSuc = this.processedData.ads.filter((ad) =>
				this.defineBranch(ad, sucursal)
			);
			let leads = 0;
			let incompletes = 0;
			adsSuc.forEach((ad) => {
				const details = ad.crm_data.leads_details || ad.leads_details || [];
				leads += details.length;

				details.forEach((l) => {
					if (l.nombre_completo && l.nombre_completo.toUpperCase().includes("INCOMPLETO"))
						incompletes++;
				});
			});
			const spend = parseFloat(fin.gasto || 0);
			const budget = parseFloat(fin.presupuesto || 0);
			const quality = leads > 0 ? (leads - incompletes) / leads : 0;
			const leadsCalidad = leads - incompletes;
			const cpaCalidad = leadsCalidad > 0 ? spend / leadsCalidad : (spend > 0 ? spend : 0);

			let status = "SANO";
			let analysis = "Operación estable.";
			let action = "Mantener estrategia.";

			if (cpaCalidad > 40 && spend > 50) {
				status = "CRITICO";
				analysis = `🚨 DESANGRE: CPA de calidad en $${cpaCalidad.toFixed(2)} (${((1 - quality) * 100) | 0}% basura).`;
				action = "APAGAR campañas tóxicas YA.";
			} else if (leads < 5 && spend > 0) {
				status = "ALERTA";
				analysis = "⚠️ INANICIÓN: Muy pocos leads para el gasto realizado.";
				action = "Revisar anuncios o aumentar presupuesto.";
			} else if (spend > budget && quality > 0.6) {
				status = "SANO";
				analysis = "📈 Inversión agresiva con buena calidad.";
				action = "Mantener y monitorear CPA.";
			}

			return { status, analysis, action, leads, quality, spend, budget };
		},
		generateAllAIDiagnoses() {
			const diag = {};

			// Esta función ahora solo se encarga de la lógica LOCAL
			this.processedData.financials.forEach((f) => {
				diag[f.sucursal] = this.generateAIDiagnosis(f.sucursal);
			});
			return diag;
		},
		getStatusBorderColor(status) {
			if (status === 'CRITICO') return '#C62828';
			if (status === 'ALERTA') return '#EF6C00';
			return '#2E7D32';
		},
		exportReport(isIA = false) {
			const target = isIA ? this.diagnosticoIA : this.localLevelDiagnoses;
			const data = JSON.stringify(target, null, 2);
			const blob = new Blob([data], { type: "application/json" });
			const url = URL.createObjectURL(blob);
			const a = document.createElement("a");
			a.href = url;
			const prefix = isIA ? 'estrategia_ia' : 'diagnostico_operativo';
			a.download = `${prefix}_${this.fechaAnalisis.replace(/[^a-z0-9]/gi, "_")}.json`;
			a.click();
		},
		getContactosAsignados() {
			this.cargar = true
			const fecha = new Date();
			fecha.setDate(fecha.getDate() - 1);
			const fechaF = fecha.toISOString().split('T')[0];

			const payload = {
				fecha_inicio: fechaF,
				fecha_final: fechaF,
				escuela: this.idSchool
			}
			this.$http.post('data.dashboard.marketing', payload).then((response) => {
				this.vendedorasDesglose = response.data.vendedoras
				return
			}).catch(error => {
				this.cargar = false
			})
		},
		getMetaAnalysisByDate() {
			this.cargar = true
			this.$http.post('api/meta/analyze/report/' + this.idSchool, { fecha: this.jsonDate })
				.then(r => {
					if (r.data.success) {
						this.descargarJSON(r.data)
						this.dialogFechaDescargaReporte = false
					}
				})
				.catch(e => this.validarError(e.response.data.message || 'Error'))
				.finally(() => this.cargar = false)
		},
		descargarJSON(json) {
			const jsonString = JSON.stringify(json, null, 2);
			const blob = new Blob([jsonString], { type: 'application/json' });

			// Generamos una URL temporal para el Blob
			const url = window.URL.createObjectURL(blob);

			// Creamos un enlace <a> invisible
			const link = document.createElement('a');
			link.href = url;
			link.download = 'report.json'; // Nombre del archivo descargado (puedes cambiarlo)

			// Agregamos al DOM, clickeamos y removemos
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);

			// Liberamos la memoria
			window.URL.revokeObjectURL(url);
		},
		async cargarCiclos() {
			this.loadingCiclos = true;
			try {
				const response = await this.$http.get('/api/marketing-cycles'); // Ajusta la URL según tu backend
				this.ciclos = response.data.map(ciclo => ({
					id: ciclo.cycle_id,
					texto: `${ciclo.cycle_name} (${ciclo.start_date} - ${ciclo.end_date})`,
				}));
			} catch (error) {
				console.error('Error cargando ciclos:', error);
			} finally {
				this.loadingCiclos = false;
			}
		},
		abrirDialogNuevoCicloSiEsNecesario(value) {
			if (value === 'nuevo') {
				this.dialogNuevoCiclo = true;
				this.disableUploadBtn = true;
				this.form.cycle_id = null; // evita que quede seleccionado "Nuevo ciclo..."
			}
		},
		async crearNuevoCiclo() {
			if (!this.$refs.formNuevoCiclo.validate()) {
				return;
			}

			this.creandoCiclo = true;

			try {
				const response = await this.$http.post('/api/marketing-cycles', {
					cycle_name: this.nuevoCiclo.name,
					start_date: this.nuevoCiclo.start_date,
					end_date: this.nuevoCiclo.end_date
				});

				const nuevo = response.data;

				await this.cargarCiclos()
				this.closeCycleDialog()
				this.form.cycle_id = nuevo.id
				this.mensaje = 'Ciclo creado y seleccionado correctamente';
				this.mensajeTipo = 'success';

			} catch (error) {
				this.mensaje = error.response.data.error || 'Error al crear el ciclo';
				this.mensajeTipo = 'error';
			} finally {
				this.creandoCiclo = false;
			}
		},
		closeCycleDialog() {
			this.dialogNuevoCiclo = false
			this.form.cycle_id = null
		},
		closeBudgetsDialog() {
			this.dialogBudgets = false
			this.form.file = null
			this.form.cycle_id = null
			this.form.school = null
			this.mensaje = null
			this.mensajeTipo = null
		},
		onCicloChange(value) {
			this.mostrarNuevoCiclo = value === 'nuevo';
			if (!this.mostrarNuevoCiclo) {
				// Si selecciona un ciclo existente, limpiar formulario nuevo
				this.nuevoCiclo = {
					name: '',
					start_date: '',
					end_date: '',
					active: 1,
				};
			}
		},
		async uploadBudgets() {
			if (!this.$refs.form.validate()) {
				return;
			}

			this.uploading = true;
			this.mensaje = 'Procesando archivo...';
			this.mensajeTipo = 'info';

			const formData = new FormData();
			formData.append('excel', this.form.file);
			formData.append('cycle_id', this.form.cycle_id);
			formData.append('school', this.form.school);

			try {
				const response = await this.$http.post(
					'/api/upload-presupuestos',
					formData,
					{
						headers: {
							'Content-Type': 'multipart/form-data',
						},
					}
				);

				this.mensaje = response.data.message || 'Presupuestos cargados exitosamente';
				this.mensajeTipo = 'success';

				setTimeout(() => {
					this.closeBudgetsDialog();
				}, 2000);

			} catch (error) {
				console.error('Error subiendo Excel:', error);

				let errorMsg = 'Error al procesar el archivo';

				if (error.response.data.error) {
					errorMsg = error.response.data.error;
					if (error.response.data.sucursal_problematica) {
						errorMsg += ` (Sucursal: "${error.response.data.sucursal_problematica}")`;
					}
				}

				this.mensaje = errorMsg;
				this.mensajeTipo = 'error';
			} finally {
				this.uploading = false;
			}

		},
	},
};
</script>

<style scoped>
canvas {
	max-height: 400px;
}
</style>
